import React from 'react';
import './Succssefully.scss';  
import logo from "../../../Assets/image (90).png";
import sidelogo from "../../../Assets/image (59).png";
import succsses from "../../../Assets/succsses.png";

export default function Login() {
  return (
  
    
     
        <div className="login-container">
          <p>Your Password is
          Successfully Changed</p>
          <img src={succsses} alt="Failed" width={80} />
          
          <button>Back to Login</button>
        </div>
    
  
  );
}
